export const TYPEAHEAD_LABEL_KEY = 'label'; // Debe coincidir con el nombre del parámetro de la opción

export const hasOption = (options) => !!options && Array.isArray(options) && options.length > 0;

export const buildOptions = (data) => data ? data.map(buildItem) : [];

const buildItem = (item) => (
    {
        label: item.name,
        value: item.id,
        disabled: false,
        item,
    }
);

export const OPTIONS = {
    companies: (data) => data.map((item) => OPTION.company(item)),
    contractors: (data) => data.map((item) => OPTION.contractor(item)),
    constructions: (data) => data.map((item) => OPTION.construction(item)),
    documentSchemas: (data) => data.map((item) => OPTION.documentSchema(item)),
};

export const OPTION = {
    company: (item) => ( {
        label: item.name,
        value: item.id,
        item,
    } ),
    contractor: (item) => ( {
        label: item.name,
        value: item.id,
        item,
    } ),
    construction: (item) => ( {
        label: item.name,
        value: item.id,
        item,
    } ),
    documentSchema: (item) => ( {
        label: item.name,
        value: item.id,
        item,
    } ),
};



// WEBPACK FOOTER //
// ./src/app/shared/utils/OptionsManager.js